import { render, staticRenderFns } from "./VerifyTeamsUser.vue?vue&type=template&id=41039704&lang=pug"
import script from "./VerifyTeamsUser.vue?vue&type=script&lang=js"
export * from "./VerifyTeamsUser.vue?vue&type=script&lang=js"
import style0 from "./VerifyTeamsUser.vue?vue&type=style&index=0&id=41039704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports